import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type CodeFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const CodeFilled = forwardRef<SVGSVGElement, CodeFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-4.062351 -4.439532) scale(0.958333)">
        <path fillRule="evenodd" clipRule="evenodd" d="M16.7607 29.1543C23.3882 29.1543 28.7607 23.7817 28.7607 17.1543C28.7607 10.5269 23.3882 5.1543 16.7607 5.1543C10.1333 5.1543 4.76074 10.5269 4.76074 17.1543C4.76074 23.7817 10.1333 29.1543 16.7607 29.1543ZM13.2643 13.4579C13.0483 13.2142 12.6053 13.2788 12.4243 13.4579V13.4597L9.09019 16.7939C9.00372 16.881 8.9552 16.9988 8.9552 17.1215C8.9552 17.2443 9.00372 17.3621 9.09019 17.4492L12.2748 20.6228C12.4428 20.7908 12.9486 20.8295 13.196 20.584C13.401 20.3809 13.377 19.8695 13.196 19.6905L10.4711 17.1095L13.2643 14.3957C13.4453 14.2019 13.532 13.7403 13.2643 13.4579ZM24.428 16.792L21.0939 13.4579V13.4597C20.9129 13.2806 20.468 13.2289 20.2336 13.4597C19.9936 13.6979 20.0526 14.176 20.2336 14.3699L23.0582 17.1132L20.3222 19.6554C20.1431 19.8345 20.0619 20.3662 20.3222 20.6246C20.5991 20.896 21.0772 20.7908 21.2452 20.6246L24.428 17.4474C24.5145 17.3602 24.563 17.2425 24.563 17.1197C24.563 16.9969 24.5145 16.8791 24.428 16.792ZM18.4963 12.5089C18.2102 12.4019 17.7616 12.5532 17.6711 12.7932H17.6693L14.6231 21.1194C14.5308 21.3575 14.8096 21.712 15.0662 21.8006C15.308 21.8911 15.74 21.7951 15.8286 21.5551L18.8563 13.2289C18.9302 12.9889 18.7696 12.6105 18.4963 12.5089Z" />
      </g>
    </svg>
  ),
);

CodeFilled.displayName = 'CodeFilled';

export default CodeFilled;
